import type { TenantTheme } from '../types';

/** 圣丰联智谷 — 默认主题。 */
export const sflTheme: TenantTheme = {
  code: 'sfl',
  displayName: '圣丰联智谷',
  logoChar: '丰',
  tagline: '都市新工业 · 活力智造谷',
  colorPrimary: '#1677FF',
  colorPrimaryAccent: '#0C447C',
  colorAccentGold: '#F5A623',
  heroGradient: ['#0A1733', '#1B2C66', '#3A2C6E', '#6E2E7A'],
  honeycombServices: [
    { icon: 'building', label: '招商选址' },
    { icon: 'certificate', label: '科技申报', variant: 'gold' },
    { icon: 'briefcase', label: '工商财税' },
    { icon: 'shield-star', label: '知产保护' },
    { icon: 'users', label: 'HR/招聘' },
    { icon: 'gavel', label: '法务咨询' },
    { icon: 'cpu', label: 'IT/数字化' },
    { icon: 'leaf', label: '环评/能评' },
    { icon: 'flask', label: '产学研', variant: 'green' },
    { icon: 'coin', label: '投融资', variant: 'gold' },
  ],
};
